import { Separator } from '@radix-ui/react-select';
import React from 'react';

import { cn } from '@/services/utils';

/**
 * Used to visually separate items in the select.
 */
const SelectSeparator = React.forwardRef<
    React.ElementRef<typeof Separator>,
    React.ComponentPropsWithoutRef<typeof Separator>
>(({ className, ...props }, ref) => (
    <Separator
        ref={ref}
        className={cn('tw--mx-1 tw-my-1 tw-h-px tw-bg-muted', className)}
        {...props}
    />
));

SelectSeparator.displayName = Separator.displayName;

export { SelectSeparator };
